import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

/**
 * Persistent overlay shown on the dispatch map when the plan's `max_map_orders`
 * cap is hiding pins.
 *
 * The hidden orders are NOT lost: they remain stored, listed in the dashboard
 * and fully dispatchable — only their marker is withheld. Copy is deliberately
 * explicit about that so operators don't think orders went missing.
 */
export default function MapOrderLimitBanner({ hiddenCount, limit }) {
  const theme = useTheme();
  const history = useHistory();

  if (!hiddenCount) return null;

  const orderWord = hiddenCount === 1 ? "pedido" : "pedidos";

  return (
    <Box
      sx={{
        position: "absolute",
        top: theme.spacing(1.5),
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1100,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        py: 1,
        maxWidth: "calc(100% - 32px)",
        borderRadius: theme.shape.borderRadius * 3,
        bgcolor: theme.palette.background.paper,
        border: `1px solid ${alpha(theme.palette.warning.main, 0.5)}`,
        boxShadow: theme.shadows[4],
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          width: 32,
          height: 32,
          borderRadius: "50%",
          bgcolor: alpha(theme.palette.warning.main, 0.15),
          color: theme.palette.warning.main,
        }}
      >
        <VisibilityOffIcon fontSize="small" />
      </Box>

      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
          {hiddenCount} {orderWord} {hiddenCount === 1 ? "oculto" : "ocultos"} no
          mapa
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Seu plano exibe até {limit} no mapa. Os demais continuam na lista e
          podem ser despachados normalmente.
        </Typography>
      </Box>

      <Button
        onClick={() => history.push("/minha-assinatura")}
        variant="contained"
        color="primary"
        size="small"
        endIcon={<RocketLaunchIcon />}
        sx={{
          flexShrink: 0,
          borderRadius: theme.shape.borderRadius * 2,
          fontWeight: 700,
          textTransform: "none",
          whiteSpace: "nowrap",
        }}
      >
        Fazer upgrade
      </Button>
    </Box>
  );
}
